import { render } from "./custom-user.vue?vue&type=template&id=18bb3e7e&lang=pug"
import script from "./custom-user.vue?vue&type=script&lang=js"
export * from "./custom-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__